import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Forms, Loading, Paging, SystemText } from '@salesperformanceint/e4shared';
import { apiGet } from 'services';
import BlobImage from 'components/blobImage';
import { Card } from '../shared';

export const Blog = ({ allowMultiple, pageSize, onAddItem, noResultsMessage, testId }) => {
    const [posts, setPosts] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [recordCount, setRecordCount] = useState(0);
    const [competency, setCompetency] = useState(null);
    const [competenciesMapped, setCompetenciesMapped] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));

    const loadPosts = () => {
        apiGet(
            `all-blogs?page=${page || 1}&sort=title&asc=true&pagesize=${pageSize}&search=${search || ''}&competency=${
                competency || 0
            }`,
            guid,
            response => {
                setPosts(response.posts);
                setRecordCount(response.records);
                setLoading(false);
            }
        );
    };

    useEffect(() => {
        setPage(1);
    }, [search, competency]);

    useEffect(() => {
        if (guid) {
            loadCompetencies();
        }
    }, [guid]);

    useEffect(() => {
        loadPosts();
    }, [guid, page, search, competency]);

    const loadCompetencies = () => {
        apiGet(`competency`, guid, response => {
            setCompetenciesMapped(response.map(c => ({ name: `${c.area} - ${c.name}`, id: c.id })));
        });
    };

    if (loading) return <Loading />;

    return (
        <div data-testid={testId}>
            {Boolean(competenciesMapped?.length) && (
                <>
                    <div>
                        <Forms.Text
                            label={SystemText('Admin/Forms/FilePicker/Content/Blog/Filters/Title')}
                            id="search"
                            placeholder={SystemText('Admin/Forms/FilePicker/Content/Blog/Fields/Search/Placeholder')}
                            value={search}
                            onChange={setSearch}
                            icon="fa-search"
                        />
                    </div>
                    <div className="no-label">
                        <Forms.Select
                            id="competency_Id"
                            placeholder={SystemText('Admin/Forms/FilePicker/Content/Blog/Fields/Competencies/Placeholder')}
                            data={competenciesMapped}
                            value={competency}
                            onChange={setCompetency}
                        />
                    </div>
                </>
            )}
            {!posts?.length ? (
                <div>{noResultsMessage}</div>
            ) : (
                <>
                    <label>{SystemText('Admin/Forms/FilePicker/Content/Blog/Title')}</label>
                    <div className="text-sm mb5">{SystemText('Admin/Forms/FilePicker/Content/Blog/SubTitle')}</div>
                    <div className="list">
                        {posts.map(post => (
                            <Card
                                addItemHandler={() => onAddItem(post, allowMultiple, 'title')}
                                title={SystemText('Admin/Forms/FilePicker/Content/Blog/Card/Title', post.title)}
                                label={post.title}
                                name={post.owner_Full_Name}
                                date={post.date}
                                key={`${post.id}-${post.owner_Id}`}
                            >
                                <BlobImage src={post.blog_Image} folder="blog_Image" partnerId={post.partner_Id} />
                            </Card>
                        ))}
                    </div>
                    {Boolean(posts?.length) && (
                        <Paging pageSize={pageSize} recordCount={recordCount} page={page} goToPage={page => setPage(page)} />
                    )}
                </>
            )}
        </div>
    );
};

export default Blog;
